// @flow

export default {
  // socket action types
  WEB_SOCKET_CONNECTED: 'WEB_SOCKET_CONNECTED',
  WEB_SOCKET_DISCONNECTED: 'WEB_SOCKET_DISCONNECTED',
  WEB_SOCKET_RECEIVED: 'WEB_SOCKET_RECEIVED',
  WEB_SOCKET_RECEIVED_BATCH: 'WEB_SOCKET_RECEIVED_BATCH',
  WEB_SOCKET_SUBSCRIBED: 'WEB_SOCKET_SUBSCRIBED',
  WEB_SOCKET_QUEUE: 'WEB_SOCKET_QUEUE',
  WEB_SOCKET_FLUSH: 'WEB_SOCKET_FLUSH',
  WEB_SOCKET_DISCONNECT: 'WEB_SOCKET_DISCONNECT',
  WEB_SOCKET_STREAMER: 'WEB_SOCKET_STREAMER',
  WEB_SOCKET_MARGIN_UPDATE: 'WEB_SOCKET_MARGIN_UPDATE',

  // depth streamer status
  WEB_SOCKET_DEPTH_DISCONNECTED: 'WEB_SOCKET_DEPTH_DISCONNECTED',
  WEB_SOCKET_DEPTH_CONNECTED: 'WEB_SOCKET_DEPTH_CONNECTED',

  // user login state
  USER_STATE_LOGGED_IN: 'USER_STATE_LOGGED_IN',
  USER_STATE_LOGGED_OUT: 'USER_STATE_LOGGED_OUT',

  // user data
  FETCH_USER_INFO: 'FETCH_USER_INFO',
  FETCH_USER_ASSETS: 'FETCH_USER_ASSETS',
  FETCH_USER_DIVIDENDS: 'FETCH_USER_DIVIDENDS',
  FETCH_USER_LOGS: 'FETCH_USER_LOGS',
  FETCH_USER_DEVICES_LIST: 'FETCH_USER_DEVICES_LIST',
  FETCH_USER_ANTI_PHISHING_CODE: 'FETCH_USER_ANTI_PHISHING_CODE',
  FETCH_ALL_USER_ASSETS: 'FETCH_ALL_USER_ASSETS',
  FETCH_ALL_USER_ASSETS_BTC_VALUES: 'FETCH_ALL_USER_ASSETS_BTC_VALUES',
  FETCH_USER_TRADE_FEE: 'FETCH_USER_TRADE_FEE',
  FETCH_USER_GAS_RATE: 'FETCH_USER_GAS_RATE',
  FETCH_USER_INFO_ERROR: 'FETCH_USER_INFO_ERROR',
  FETCH_USER_ASSETS_ERROR: 'FETCH_USER_ASSETS_ERROR',
  FETCH_USER_DIVIDENDS_ERROR: 'FETCH_USER_DIVIDENDS_ERROR',
  FETCH_USER_LOGS_ERROR: 'FETCH_USER_LOGS_ERROR',
  FETCH_USER_DEVICES_LIST_ERROR: 'FETCH_USER_DEVICES_LIST_ERROR',
  FETCH_USER_ANTI_PHISHING_CODE_ERROR: 'FETCH_USER_ANTI_PHISHING_CODE_ERROR',
  FETCH_ALL_USER_ASSETS_ERROR: 'FETCH_ALL_USER_ASSETS_ERROR',
  FETCH_ALL_USER_ASSETS_BTC_VALUES_ERROR: 'FETCH_ALL_USER_ASSETS_BTC_VALUES_ERROR',
  FETCH_USER_TRADE_FEE_ERROR: 'FETCH_USER_TRADE_FEE_ERROR',
  FETCH_USER_GAS_RATE_ERROR: 'FETCH_USER_GAS_RATE_ERROR',
  SET_USER_INFO: 'SET_USER_INFO',
  SET_ANTI_CODE: 'SET_ANTI_CODE',
  SET_USER_ASSETS: 'SET_USER_ASSETS',
  SET_USER_DIVIDENDS: 'SET_USER_DIVIDENDS',
  SET_USER_LOGS: 'SET_USER_LOGS',
  SET_USER_DEVICES_LIST: 'SET_USER_DEVICES_LIST',
  SET_USER_ANTI_PHISHING_CODE: 'SET_USER_ANTI_PHISHING_CODE',
  SET_ALL_USER_ASSETS: 'SET_ALL_USER_ASSETS',
  SET_ALL_USER_ASSETS_BTC_VALUES: 'SET_ALL_USER_ASSETS_BTC_VALUES',
  SET_USER_TRADE_FEE: 'SET_USER_TRADE_FEE',
  SET_USER_GAS_RATE: 'SET_USER_GAS_RATE',
  SET_CREATE_ACCOUNT_FOCUS: 'SET_CREATE_ACCOUNT_FOCUS',
  FETCH_KTC_INFO: 'FETCH_KTC_INFO',
  FETCH_KTC_INFO_SUCCESS: 'FETCH_KTC_INFO_SUCCESS',
  FETCH_KTC_INFO_ERROR: 'FETCH_KTC_INFO_ERROR',
  FETCH_BANK_INFO: 'FETCH_BANK_INFO',
  FETCH_BANK_INFO_SUCCESS: 'FETCH_BANK_INFO_SUCCESS',
  FETCH_BANK_INFO_ERROR: 'FETCH_BANK_INFO_ERROR',
  SET_BASE_DETAIL: 'SET_BASE_DETAIL',

  // data action types (on first load)
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_EXCHANGE_INFO: 'SET_EXCHANGE_INFO',
  SET_META_DATA: 'SET_META_DATA',
  SET_LOCALE_DATA: 'SET_LOCALE_DATA',
  SET_NEWS_DATA: 'SET_NEWS_DATA',

  // market data
  FETCH_DEPTH_DATA: 'FETCH_DEPTH_DATA',
  FETCH_TRADES_DATA: 'FETCH_TRADES_DATA',
  FETCH_USER_TRADES_DATA: 'FETCH_USER_TRADES_DATA',
  FETCH_OPEN_ORDERS_DATA: 'FETCH_OPEN_ORDERS_DATA',
  FETCH_TRADE_ORDERS_DATA: 'FETCH_TRADE_ORDERS_DATA',
  FETCH_FAVORITES_DATA: 'FETCH_FAVORITES_DATA',
  FETCH_CURRENCY_RATE_DATA: 'FETCH_CURRENCY_RATE_DATA',
  FETCH_DEPTH_DATA_ERROR: 'FETCH_DEPTH_DATA_ERROR',
  FETCH_TRADES_DATA_ERROR: 'FETCH_TRADES_DATA_ERROR',
  FETCH_USER_TRADES_DATA_ERROR: 'FETCH_USER_TRADES_DATA_ERROR',
  FETCH_OPEN_ORDERS_ERROR: 'FETCH_OPEN_ORDERS_ERROR',
  FETCH_TRADE_ORDERS_ERROR: 'FETCH_TRADE_ORDERS_ERROR',
  FETCH_FAVORITES_DATA_ERROR: 'FETCH_FAVORITES_DATA_ERROR',
  FETCH_CURRENCY_RATE_DATA_ERROR: 'FETCH_CURRENCY_RATE_DATA_ERROR',
  SET_DEPTH_DATA: 'SET_DEPTH_DATA',
  SET_TRADES_DATA: 'SET_TRADES_DATA',
  SET_USER_TRADES_DATA: 'SET_USER_TRADES_DATA',
  SET_USER_TRADES_DATA_WITH_BEFORE: 'SET_USER_TRADES_DATA_WITH_BEFORE',
  SET_USER_TRADES_DATA_PERIOD: 'SET_USER_TRADES_DATA_PERIOD',
  SET_OPEN_ORDERS_DATA: 'SET_OPEN_ORDERS_DATA',
  SET_MARGIN_OPEN_ORDERS_DATA: 'SET_MARGIN_OPEN_ORDERS_DATA',
  SET_TRADE_ORDERS_DATA: 'SET_TRADE_ORDERS_DATA',
  SET_MARGIN_TRADE_ORDERS_DATA: 'SET_MARGIN_TRADE_ORDERS_DATA',
  SET_TRADE_ORDERS_DATA_WITH_BEFORE: 'SET_TRADE_ORDERS_DATA_WITH_BEFORE',
  SET_TRADE_ORDERS_PERIOD: 'SET_TRADE_ORDERS_PERIOD',
  SET_FAVORITES_DATA: 'SET_FAVORITES_DATA',
  SET_FETCH_COMPLETED: 'SET_FETCH_COMPLETED',
  SET_CURRENCY_RATE_DATA: 'SET_CURRENCY_RATE_DATA',
  SET_NATIVE_CURRENCY_DATA: 'SET_NATIVE_CURRENCY_DATA',
  SET_TO_FIAT_RATE: 'SET_TO_FIAT_RATE',
  SET_MARKETS_DATA: 'SET_MARKETS_DATA',
  SET_TOP_MOVERS: 'SET_TOP_MOVERS',

  // clear market data
  CLEAR_DEPTH_DATA: 'CLEAR_DEPTH_DATA',
  CLEAR_TRADES_DATA: 'CLEAR_TRADES_DATA',
  CLEAR_USER_TRADES_DATA: 'CLEAR_USER_TRADES_DATA',

  // order action types
  PLACE_ORDER_START: 'PLACE_ORDER_START',
  PLACE_ORDER_SUCCESS: 'PLACE_ORDER_SUCCESS',
  PLACE_ORDER_FAILED: 'PLACE_ORDER_FAILED',
  DELETE_ORDER_START: 'DELETE_ORDER_START',
  DELETE_ORDER_SUCCESS: 'DELETE_ORDER_SUCCESS',
  DELETE_ORDER_FAILED: 'DELETE_ORDER_FAILED',
  // user action types
  DELETE_DEVICE_HISTORY_SUCCESS: 'DELETE_DEVICE_HISTORY_SUCCESS',
  DELETE_DEVICE_HISTORY_ERROR: 'DELETE_DEVICE_HISTORY_ERROR',

  // favorites action types
  HANDLE_FAVORITE_DATA: 'HANDLE_FAVORITE_DATA',
  HANDLE_FAVORITE_DATA_SUCCESS: 'HANDLE_FAVORITE_DATA_SUCCESS',
  HANDLE_FAVORITE_DATA_FAILED: 'HANDLE_FAVORITE_DATA_FAILED',
  // set order form price and amount
  SET_ORDERFORM_PRICE_AMOUNT: 'SET_ORDERFORM_PRICE_AMOUNT',

  // set is fetching data
  IS_DATA_LOADING: 'IS_DATA_LOADING',

  // change current indicator and over lay
  CHANGE_CHART_INDICATOR: 'CHANGE_CHART_INDICATOR',

  SET_LISTEN_KEY: 'SET_LISTEN_KEY',
  SET_MARGIN_LISTEN_KEY: 'SET_MARGIN_LISTEN_KEY',
  SET_DEVICE_HISTORY_DATA: 'SET_DEVICE_HISTORY_DATA',

  SET_THEME: 'SET_THEME',
  SET_SELECTED_PAIR: 'SET_SELECTED_TAB_PAIR',
  SET_SELECTED_ASSET_TAB: 'SET_SELECTED_ASSET_TAB',
  SET_SELECTED_STABLE_COIN_TABS: 'SET_SELECTED_STABLE_COIN_TABS',

  SET_JPUSH_DATA: 'SET_JPUSH_DATA',
  CLEAR_JPUSH_DATA: 'CLEAR_JPUSH_DATA',
  SET_USER_MONEY_LOG: 'SET_USER_MONEY_LOG',

  // desposit & withdraw
  FETCH_ASSETS: 'FETCH_ASSETS',
  FETCH_ASSETS_SUCCESS: 'FETCH_ASSETS_SUCCESS',
  FETCH_ASSETS_FAILED: 'FETCH_ASSETS_FAILED',
  SET_SYMBOL_BY_ASSET: 'SET_SYMBOL_BY_ASSET',
  SET_CHARGE_ADDRESS: 'SET_CHARGE_ADDRESS',
  FETCH_WITHDRAW_ADDRESS: 'FETCH_WITHDRAW_ADDRESS',
  FETCH_WITHDRAW_ADDRESS_SUCCESS: 'FETCH_WITHDRAW_ADDRESS_SUCCESS',
  FETCH_WITHDRAW_ADDRESS_FAILED: 'FETCH_WITHDRAW_ADDRESS_SUCCESS',
  SET_CUR_USER_ASSETS: 'SET_CUR_USER_ASSETS',
  SET_GENERATE_USER_CHARGE_ADDRESS: 'SET_GENERATE_USER_CHARGE_ADDRESS',
  FETCH_ASSET_LOG_EXTRA_DETAIL: 'FETCH_ASSET_LOG_EXTRA_DETAIL',
  FETCH_ASSET_LOG_EXTRA_DETAIL_SUCCESS: 'FETCH_ASSET_LOG_EXTRA_DETAIL_SUCCESS',
  FETCH_ASSET_LOG_EXTRA_DETAIL_FAILED: 'FETCH_ASSET_LOG_EXTRA_DETAIL_FAILED',
  FETCH_USER_MONEY_LOG_CRYPTO: 'FETCH_USER_MONEY_LOG_CRYPTO',
  FETCH_USER_MONEY_LOG_CRYPTO_SUCCESS: 'FETCH_USER_MONEY_LOG_CRYPTO_SUCCESS',
  FETCH_USER_MONEY_LOG_CRYPTO_FAILED: 'FETCH_USER_MONEY_LOG_CRYPTO_FAILED',
  // send SMS
  SET_SEND_SMS_STATUS: 'SET_SEND_SMS_STATUS',

  // bind Xfers
  SEND_XFERS_OPT: 'SEND_XFERS_OPT',
  SEND_XFERS_OPT_SUCCESS: 'SEND_XFERS_OPT_SUCCESS',
  SEND_XFERS_OPT_FAILED: 'SEND_XFERS_OPT_FAILED',
  BIND_XFERS_CONFIRM: 'BIND_XFERS_CONFIRM',
  BIND_XFERS_CONFIRM_SUCCESS: 'BIND_XFERS_CONFIRM_SUCCESS',
  BIND_XFERS_CONFIRM_FAILED: 'BIND_XFERS_CONFIRM_FAILED',

  SET_ACTIVITIES: 'SET_ACTIVITIES',

  // user config
  FETCH_USER_CONFIG: 'FETCH_USER_CONFIG',
  FETCH_USER_CONFIG_SUCCESS: 'FETCH_USER_CONFIG_SUCCESS',
  FETCH_USER_CONFIG_FAILED: 'FETCH_USER_CONFIG_FAILED',

  FETCH_ASSET_PIC: 'FETCH_ASSET_PIC',
  FETCH_ASSET_PIC_ERROR: 'FETCH_ASSET_PIC_ERROR',

  FETCH_BTC_TO_USDT_RATE_SUCCESS: 'FETCH_BTC_TO_USDT_RATE_SUCCESS',

  // sub account

  // account management
  ADD_USER_SUB_ACCOUNT_SUCCESS: 'ADD_USER_SUB_ACCOUNT_SUCCESS',
  FETCH_USER_SUB_EMAIL_SUCCESS: 'FETCH_USER_SUB_EMAIL_SUCCESS',
  FETCH_USER_SUB_ACCOUNT_SUCCESS: 'FETCH_USER_SUB_ACCOUNT_SUCCESS',
  UPDATE_SUB_ACCOUNT_STATUS_SUCCESS: 'UPDATE_SUB_ACCOUNT_STATUS_SUCCESS',
  RESET_SUB_USER_2FA_SUCCESS: 'RESET_SUB_USER_2FA_SUCCESS',
  RESEND_SUB_ACCOUNT_EMAIL: 'RESEND_SUB_ACCOUNT_EMAIL',
  UPDATA_USER_COMMISSION_STATUS_SUCCESS: 'UPDATA_USER_COMMISSION_STATUS_SUCCESS',

  // login history
  FETCH_USER_SUB_LOGIN_HISTORY_SUCCESS: 'FETCH_USER_SUB_LOGIN_HISTORY_SUCCESS',

  // order management
  FETCH_USER_SUB_OPEN_ORDERS_SUCCESS: 'FETCH_USER_SUB_OPEN_ORDERS_SUCCESS',
  FETCH_USER_SUB_ORDERS_HISTORY_SUCCESS: 'FETCH_USER_SUB_ORDERS_HISTORY_SUCCESS',
  FETCH_USER_SUB_ORDERS_HISTORY_DETAIL_SUCCESS: 'FETCH_USER_SUB_ORDERS_HISTORY_DETAIL_SUCCESS',
  FETCH_USER_SUB_TRADES_HISTORY_SUCCESS: 'FETCH_USER_SUB_TRADES_HISTORY_SUCCESS',
  DELETE_SUB_OPEN_ORDER_SUCCESS: 'DELETE_SUB_OPEN_ORDER_SUCCESS',
  DELETE_ALL_SUB_OPEN_ORDER_SUCCESS: 'DELETE_ALL_SUB_OPEN_ORDER_SUCCESS',

  // asset management
  FETCH_SUB_USER_ASSET_SUCCESS: 'FETCH_SUB_USER_ASSET_SUCCESS',
  FETCH_SUB_USER_ASSET_DETAIL_SUCCESS: 'FETCH_SUB_USER_ASSET_DETAIL_SUCCESS',
  FETCH_PARRENT_TOTAL_ASSET_FOR_BTC_SUCCESS: 'FETCH_Parrent_TOTAL_ASSET_FOR_BTC_SUCCESS',
  FETCH_SUB_TOTAL_ASSET_FOR_BTC_SUCCESS: 'FETCH_SUB_TOTAL_ASSET_FOR_BTC_SUCCESS',

  // asset transfer
  FETCH_ASSET_TRANSFER_HISTORY_SUCCESS: 'FETCH_ASSET_TRANSFER_HISTORY_SUCCESS',
  FETCH_SUB_ACCOUNT_ASSET_BY_COIN_SUCCESS: 'FETCH_SUB_ACCOUNT_ASSET_BY_COIN_SUCCESS',
  FETCH_ASSET_TRANSFER_HISTORY_BY_ID_SUCCESS: 'FETCH_ASSET_TRANSFER_HISTORY_BY_ID_SUCCESS',

  // socket
  WEB_SOCKET_RECEIVED_DEPTH: 'WEB_SOCKET_RECEIVED_DEPTH',
  WEB_SOCKET_RECEIVED_TRADE: 'WEB_SOCKET_RECEIVED_TRADE',
  WEB_SOCKET_RECEIVED_TICKERS: 'WEB_SOCKET_RECEIVED_TICKERS',

  // TODO migrate
};

export type Type = {
  type: string,
  data?: Object,
  pagination?: Object,
};
